const locale = {
    WELCOME_BACK: 'Hello {{displayName}}, Welcome to Fix & Clean!',
    SETTINGS: 'Settings',
    CLEAN_ROOMS: 'Cleaned rooms',
    UNASSIGNED_ROOMS: 'Unassigned rooms',
    EXPRESS_ROOMS: 'Express rooms',
    CLEANING_ROOMS: 'Cleaning rooms',
    CHECKOUT_ROOMS: 'Checkout cleaning',
    MAINTENANCE_REQUESTS: 'Active requests',
    EXPECTED_CHECK_INS: 'Expected Check-ins',
    EXPECTED_CHECK_OUTS: 'Expected Check-outs',
    CANCELLATIONS: 'Cancellations',
    COMING_SOON: 'Coming Soon',
    PMS_INTEGRATION_DATA: 'PMS Integration Data',
};

export default locale;